import React, { ReactNode } from 'react'
import { useReactTable, flexRender, ColumnDef, getCoreRowModel, getSortedRowModel } from '@tanstack/react-table';
import ArrowUpDownSvg from '@/shared/assets/images/ArrowsLeftRight.svg'
import ArrowUpSvg from '@/shared/assets/images/ArrowUp2.svg'
import ArrowDownSvg from '@/shared/assets/images/ArrowDown2.svg'

interface TableProps<T = any> {
    columns: ColumnDef<T, any>[],
    data: T[],
    tbody?: ReactNode
    classNames?: {
        table?: string
        tbody?: string
        thead?: string
    }
}

export const Table: React.FC<TableProps> = ({ columns, classNames, data, tbody }) => {
    const table = useReactTable({
        columns,
        data,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel()
    })

    return (
        <div className='overflow-auto'>
            <table className={[`react-table`, classNames?.table].filter(Boolean).join(' ')}>
                <thead className={classNames?.thead}>
                    {table.getHeaderGroups().map((hG, index) => (
                        <tr key={hG.id + '@' + index}>
                            {hG.headers.map((col, index) => (
                                <th {...(col.column.columnDef.meta as any)?.cellProps} key={col.id + '@' + index}>
                                    <div className={`gap-2 flex items-center`}>
                                        {flexRender(
                                            col.column.columnDef.header,
                                            col.getContext()
                                        )}
                                        {col.column.getCanSort() && (
                                            <span className='cursor-pointer' onClick={col.column.getToggleSortingHandler()}>
                                                {col.column.getIsSorted() ? (
                                                    col.column.getNextSortingOrder() === 'asc' ? (
                                                        <ArrowUpSvg />
                                                    ) : (
                                                        <ArrowDownSvg />
                                                    )
                                                ) : (
                                                    <ArrowUpDownSvg className="rotate-90" />
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody className={classNames?.tbody}>
                    {table.getSortedRowModel().rows.map((row, index) => {
                        return (
                            <tr key={row.id + '@' + index}>
                                {row.getVisibleCells().map((cell, index) => {
                                    return (
                                        <td key={cell.id + '@' + index}>
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
                    {tbody}
                </tbody>
            </table>
        </div>
    );
}